/**
 * @group UI
 * @summary UI-specific messages and text constants
 * 
 * @remarks
 * This constant contains messages and text used in UI components
 * for consistent user feedback and error handling.
 * 
 * @example
 * ```typescript
 * import { UI_MESSAGES } from '@shared/constants';
 * 
 * toast({
 *   title: UI_MESSAGES.SUCCESS.OPERATION_COMPLETED,
 *   description: UI_MESSAGES.SUCCESS.DATA_SAVED
 * });
 * ```
 */
export const UI_MESSAGES = {
  SUCCESS: {
    OPERATION_COMPLETED: 'Success',
    DATA_SAVED: 'Data saved successfully',
    DATA_DELETED: 'Data deleted successfully',
    DATA_UPDATED: 'Data updated successfully',
    ACCOUNT_CREATED: 'Account created successfully',
    SIGNED_IN: 'Signed in successfully'
  },
  ERROR: {
    GENERAL_ERROR: 'Error',
    FORM_SUBMISSION_ERROR: 'Form submission error',
    FILE_UPLOAD_ERROR: 'File upload error',
    DATA_FETCH_ERROR: 'Error fetching data',
    CONFIGURATION_ERROR: 'Configuration error',
    ADD_ITEM_ERROR: 'Error adding item',
    REMOVE_ITEM_ERROR: 'Error removing item'
  },
  AUTH: {
    SIGNING_IN: 'Signing in...',
    CREATING_ACCOUNT: 'Creating account...',
    SIGN_IN: 'Sign In',
    SIGN_UP: 'Sign Up'
  },
  STATUS: {
    LOADING: 'loading'
  }
} as const;
